<template>
  <div id="app">
    <div v-if="showNotification && announcement.announcement" class="notification">
      <p v-html="announcement.announcement"></p>
      <svg
        @click="close"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 192 192"
        width="24"
        height="24"
      >
        <g
          fill="none"
          stroke-miterlimit="10"
          font-family="none"
          font-weight="none"
          font-size="none"
          text-anchor="none"
          style="mix-blend-mode:normal"
        >
          <path d="M0 192V0h192v192z"></path>
          <path
            d="M29.64 24.12l-5.52 5.52L90.48 96l-66.36 66.36 5.52 5.52L96 101.52l66.36 66.36 5.52-5.52L101.52 96l66.36-66.36-5.52-5.52L96 90.48z"
            fill="#fff"
          ></path>
        </g>
      </svg>
    </div>
    <Header/>
    <router-view/>
  </div>
</template>

<script>
// import { getCurrentAnnouncement } from './utils/api/announcement';
import "./assets/scss/main.scss";
import Header from "./components/Header";

export default {
  name: "App",
  components: {
    Header
  },
  data() {
    return {
      showNotification: false,
      announcement: {},
      announcementsLoaded: false
    };
  },
  created() {
    // this.getAnnouncement();
  },
  watch: {
    // announcement(val) {
    // 	this.showNotification = true;
    // }
  },
  methods: {
    close() {
      this.showNotification = false;
    },
    getAnnouncement() {
      getCurrentAnnouncement().then(response => {
        if (response.status === 200) {
          this.announcement = response.data.data;
          this.announcementsLoaded = true;
        }
      });
      return true;
    }
  }
};
</script>


<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.notification {
  background: #f35517;
  color: $white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 75px;
  padding: 10px 30px;
  * {
    font-size: 18px;
  }
}
</style>
